import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import App from './App'
import { i18nReady } from './i18n/i18n'
import store, { Provider } from './store'
import './assets/css/mixpanel.css'
import './services.css'
import './charts.css'
import './transitions.css'
import './clock.css'
import './faro'

const rootElement: HTMLElement = document.getElementById('root')

const render = () => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <App />
      </Provider>
    </AppContainer>,
    rootElement,
  )
}

i18nReady.then(render)

if (
  process.env.NODE_ENV !== 'production' &&
  module.hot &&
  process.env.REACT_APP_HOT_RELOADING === 'true'
) {
  module.hot.accept('./App', () => {
    render()
  })
}
